module.exports = __webpack_public_path__ + "img/racecourse-fairview-poly-3150.b733c7bb.svg";